import React from "react";
import FormHC from "../components/form";
import ServiciosIAComponent from "../components/ServiciosIA";

function ServiciosIA() {
    return (
        <>
        <main>
            <ServiciosIAComponent />
            <FormHC />
        </main>
        </>
    );
}

export default ServiciosIA;